import React from 'react';
import './Career.css';

const Career = () => {
  const openings = [
    {
      id: 1,
      title: 'Oil and Gas Specialist',
      department: 'Energy & Resources',
      location: 'Abuja, Nigeria',
      type: 'Full-time',
      status: 'open',
      description: 'Provide technical expertise in oil and gas operations, project development, and investment facilitation across Africa. Lead strategic initiatives in the energy sector.'
    },
    {
      id: 2,
      title: 'Renewable Energy Specialist',
      department: 'Energy & Resources',
      location: 'Abuja, Nigeria',
      type: 'Full-time',
      status: 'open',
      description: 'Drive renewable energy projects, policy development, and sustainable investment initiatives across Africa. Focus on solar, wind, and green energy solutions.'
    },
    {
      id: 3,
      title: 'Project Manager',
      department: 'Project Development',
      location: 'Abuja, Nigeria',
      type: 'Full-time',
      status: 'open',
      description: 'Lead and coordinate infrastructure, climate, and investment projects from conception to completion. Manage stakeholder engagement and project delivery.'
    },
    {
      id: 4,
      title: 'Retired Official (10-15 Years Experience)',
      department: 'Advisory & Governance',
      location: 'Abuja, Nigeria',
      type: 'Consultancy',
      status: 'coming-soon',
      description: 'Senior advisory role for retired officials with 10-15 years of experience in government, diplomacy, or international development. Position opening soon.'
    }
  ];

  const openPositions = openings.filter(job => job.status === 'open');
  const comingSoonPositions = openings.filter(job => job.status === 'coming-soon');

  const volunteerAreas = [
    { icon: '📋', title: 'Research & Policy', description: 'Conduct research on African policy issues and investment opportunities' },
    { icon: '🤝', title: 'Event Coordination', description: 'Support the planning and execution of conferences and trade missions' },
    { icon: '💻', title: 'Digital & Communications', description: 'Assist with website, social media, and communications activities' },
    { icon: '📊', title: 'Project Support', description: 'Provide organizational and logistical support for programmes' }
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Careers</h1>
        <p>Join the ABVIG team and be part of Africa's transformation</p>
      </section>

      <section className="career-section">
        <div className="container">
          {/* Join Our Team - GFVIPEP Introduction */}
          <div className="career-intro">
            <h2>Join Our Team</h2>
            <p>
              At <strong>Africa Business Ventures & Investment Group (ABVIG)</strong>, we are building a 
              diverse community of professionals, researchers, volunteers, interns, fellows and industry 
              experts committed to advancing sustainable development across Africa.
            </p>
            <p>
              Through our <strong>Global Fellowship, Volunteer, Internship, Professional Engagement & 
              Experts Programme (GFVIPEP)</strong>, we accept applications throughout the year from 
              talented individuals who are passionate about infrastructure development, climate action, 
              investment promotion, project preparation, research, policy, and institutional development.
            </p>
            <p>
              Participants gain hands-on experience by contributing to high-impact projects, international 
              conferences, trade and investment missions, policy research, and strategic initiatives while 
              working alongside leading governments, development partners, investors and global institutions 
              to help <strong>Mobilise Partnerships, Drive Investment and Transform Africa.</strong>
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="career-benefits">
            <div className="career-benefit-card">
              <span className="benefit-icon">🌍</span>
              <h4>Global Exposure</h4>
              <p>Work on international projects and collaborate with partners worldwide.</p>
            </div>
            <div className="career-benefit-card">
              <span className="benefit-icon">📈</span>
              <h4>Career Growth</h4>
              <p>Opportunities for professional development and advancement.</p>
            </div>
            <div className="career-benefit-card">
              <span className="benefit-icon">🤝</span>
              <h4>Impactful Work</h4>
              <p>Contribute to Africa's infrastructure, climate, and investment future.</p>
            </div>
            <div className="career-benefit-card">
              <span className="benefit-icon">💼</span>
              <h4>Dynamic Team</h4>
              <p>Work with passionate professionals across multiple countries.</p>
            </div>
          </div>

          {/* Volunteer Opportunities */}
          <div className="career-volunteer">
            <h2 className="section-title">Volunteer Opportunities</h2>
            <div className="volunteer-content">
              <p>
                ABVIG welcomes volunteers who are passionate about Africa's development and want to 
                contribute their skills and expertise. Volunteers play a vital role in our programmes, 
                from research and event coordination to communications and project support.
              </p>
              <div className="volunteer-grid">
                {volunteerAreas.map((item, index) => (
                  <div className="volunteer-item" key={index}>
                    <span className="volunteer-icon">{item.icon}</span>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Open Positions */}
          <div className="career-openings">
            <h2 className="section-title">Current Openings</h2>
            {openPositions.map((job) => (
              <div className="job-card" key={job.id}>
                <div className="job-header">
                  <h3>{job.title}</h3>
                  <span className="job-type">{job.type}</span>
                </div>
                <div className="job-details">
                  <span className="job-dept">🏢 {job.department}</span>
                  <span className="job-location">📍 {job.location}</span>
                </div>
                <p className="job-description">{job.description}</p>
                <button className="btn-gold job-apply-btn" onClick={() => window.location.href = '/contact-us'}>
                  Apply Now
                </button>
              </div>
            ))}
          </div>

          {/* Coming Soon Positions */}
          {comingSoonPositions.length > 0 && (
            <div className="career-coming-soon">
              <h2 className="section-title">Coming Soon</h2>
              <div className="coming-soon-grid">
                {comingSoonPositions.map((job) => (
                  <div className="coming-soon-card" key={job.id}>
                    <div className="coming-soon-icon">🔜</div>
                    <h3>{job.title}</h3>
                    <p className="coming-soon-dept">{job.department}</p>
                    <p className="coming-soon-desc">{job.description}</p>
                    <span className="coming-soon-badge">Opening Soon</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* CTA Section */}
          <div className="career-cta">
            <h3>Ready to Make an Impact?</h3>
            <p>
              Join ABVIG and be part of Africa's transformation. Send your CV to 
              <a href="mailto:careers@abvig.com"> careers@abvig.com</a> or apply through our 
              volunteer programmes.
            </p>
            <div className="cta-buttons">
              <button className="btn-gold" onClick={() => window.location.href = '/contact-us'}>
                Apply Now
              </button>
              <button className="btn-outline-gold" onClick={() => window.location.href = '/interns-volunteers'}>
                Learn More About Volunteering
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Career;